// Back control shown at the top of BKFC screens that previously had no way
// to reverse a step (the Figma flow only draws forward navigation).
export function BkfcBackButton({
  onClick,
  className = "",
}: {
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      onClick={onClick}
      aria-label="Go back"
      className={`flex items-center gap-1 text-base font-bold text-black transition-opacity hover:opacity-70 ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
      Back
    </button>
  );
}
